import catIcon from '@common/_assets/images/icon-cat.svg';
import dogIcon from '@common/_assets/images/icon-dog.svg';
import { useQuery } from '@common/hooks';
import { IntakeService } from '@common/services';
import { Page } from '@customer/components/layout/.';
import { useCreateIntakeStore } from '@customer/stores/hooks';
import { faMapMarkerAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { Button, Col, Image, ListGroup, Row } from 'react-bootstrap';
import { usePromiseTracker } from 'react-promise-tracker';
import { useNavigate, useParams } from 'react-router';
import iconTickBlue from '../../_assets/images/icon-tick-blue.svg';

export const IntakeView = observer(() => {
    const store = useCreateIntakeStore({ shouldSetContext: false });
    const { intakepublicid } = useParams();
    let query = useQuery();
    const navigate = useNavigate();

    const { promiseInProgress } = usePromiseTracker({
        delay: 500,
        area: IntakeService.tags.getIntake
    });

    useEffect(() => {
        if (intakepublicid) {
            store.setParamValues(intakepublicid, query.get('linkSource') || 'email');
            store.getIntake().catch(() => {
                navigate("/verification");
            });
        }
    }, [store, intakepublicid, query, navigate]);

    const onCustomerProfileClick = () =>
        navigate(`/customerprofile/${store.intakePublicId}`);

    const onPetProfileClick = (intakePetId: number) =>
        navigate(`/petprofile/${store.intakePublicId}/${intakePetId}`);

    return (
        <>
            <Page className="intake">
                <Page.Content>
                    {(!promiseInProgress) ?
                        <>
                            <Row>
                                <Col xs={12}>
                                    <h3 className="header">{store.intake.isClinicCancelled ? 'All Set! We look forward to seeing you.' : 'Help us get ready for your pet\'s appointment.'}</h3>
                                </Col>
                            </Row>
                            <Row className="pb-2">
                                <Col xs={2}>
                                    <div className="intake-location">
                                        <div className="d-flex justify-content-center location-icon">
                                            <FontAwesomeIcon icon={faMapMarkerAlt} />
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={10} className="px-0">
                                    <div className="sm-type mx-0">
                                        <h4>At {store.intake.storePartnerName}</h4>
                                        <p className="mb-1">{store.intake.storeAddress}</p>
                                        <p className="mb-1">{store.intake.visitDateAndTimes}</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    store.intake.isClinicCancelled ?
                                        <Col xs={12}>
                                            <h3 className="error">This clinic has been cancelled</h3>
                                            <div>
                                                <Button type="button" onClick={() => { navigate(`/rebook/${store.intake.clinicId}/${store.intake.targetRebookingReservation?.reservationPublicId}`) }}>Re-book Your Appointment</Button>
                                            </div>
                                        </Col>
                                        :
                                        <>
                                            <Col xs={12} className="my-2">
                                                <div>
                                                    {
                                                        store.intake.isIntakeCompleted ?
                                                            <p className="sub-header mb-1">Please review and complete prior to your pet&apos;s appointment</p>
                                                            : null
                                                    }
                                                </div>
                                            </Col>

                                            <Col xs={12}>
                                                <ListGroup as="ul">
                                                    {/** Customer Intake */}
                                                    <ListGroup.Item as="li" className="info-container" onClick={() => onCustomerProfileClick()}>
                                                        <div className="col1">
                                                            <div className="cont">
                                                                <div className={classNames({ 'green-bg': store.intake.responseCompleteDate != null }, 'cont-col1 status-container')}>
                                                                    {
                                                                        store.intake.responseCompleteDate ?
                                                                            <Image src={iconTickBlue} className="intake-saved" />
                                                                            : null
                                                                    }
                                                                </div>
                                                                <div className="cont-col2">
                                                                    <div className="desc">
                                                                        <FontAwesomeIcon icon={faUser} />
                                                                        <label className="intake-name">Your information</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col2">
                                                            <div className="nav-arrow pull-right"></div>
                                                        </div>
                                                    </ListGroup.Item>

                                                    {/** Pet Intake Items */}
                                                    {
                                                        store.intake.pets.map((pet, index) => (
                                                            <ListGroup.Item key={'pet_' + index} as="li" className="info-container" onClick={() => onPetProfileClick(pet.intakePetId)}>
                                                                <div className="col1">
                                                                    <div className="cont">
                                                                        <div className={classNames({ 'green-bg': pet.responseCompleteDate != null }, 'cont-col1 status-container')}>
                                                                            {
                                                                                pet.responseCompleteDate ?
                                                                                    <Image src={iconTickBlue} className="intake-saved" />
                                                                                    : null
                                                                            }
                                                                        </div>
                                                                        <div className="cont-col2">
                                                                            <div className="desc">
                                                                                {
                                                                                    pet.speciesId == 1 ?
                                                                                        <Image src={dogIcon} height={26} width={24} />
                                                                                        :
                                                                                        pet.speciesId == 2 ?
                                                                                            <Image src={catIcon} height={26} width={24} />
                                                                                            : null
                                                                                }
                                                                                <label className="intake-name">{pet.name}</label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col2">
                                                                    <div className="nav-arrow pull-right"></div>
                                                                </div>
                                                            </ListGroup.Item>
                                                        ))
                                                    }
                                                </ListGroup>
                                            </Col>
                                        </>
                                }
                            </Row>
                        </>
                        : null
                    }
                </Page.Content>
            </Page>
        </>
    )
});
